import SkeletonBone from './SkeletonBone';

/**
 * Mimics an article body while a post loads.
 *
 * Rendered inside the already-mounted BlogReaderLayout (sidebar, nav etc. are
 * already on screen), so only the article text area needs to be shown as a
 * skeleton — keeping the layout perfectly stable during the load.
 */
export default function PostContentSkeleton() {
  return (
    <div className="flex-1 space-y-4 py-4" aria-busy="true" aria-label="Loading post…">
      {/* Post title */}
      <SkeletonBone className="h-8 w-2/3" />
      {/* First paragraph */}
      <SkeletonBone className="h-4 w-full" />
      <SkeletonBone className="h-4 w-5/6" />
      <SkeletonBone className="h-4 w-full" />
      <SkeletonBone className="h-4 w-4/6" />
      {/* Second paragraph */}
      <SkeletonBone className="mt-6 h-4 w-full" />
      <SkeletonBone className="h-4 w-5/6" />
      <SkeletonBone className="h-4 w-full" />
      <SkeletonBone className="h-4 w-3/4" />
    </div>
  );
}
